import { render, staticRenderFns } from "./CorpLogistics.vue?vue&type=template&id=8779ca84"
import script from "./CorpLogistics.vue?vue&type=script&lang=js"
export * from "./CorpLogistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports